<template>
	<div class="bg-white p-4">
		<h2 class="font-bold">{{ title }}</h2>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: "RoundStatisticContainer",
	props: {
		title: {
			type: String,
			required: true
		}
	}
}
</script>
